/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcDtccUtcV1UtcFixSessionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_DTCC_UTC_V1_UTC_FIX_SESSION_EVENT_ENTITY_NAME = 'exc.dtcc.utc.v1.UtcFixSessionEvent';
export const excDtccUtcV1UtcFixSessionEventEntity = new schema.Entity<ExcDtccUtcV1UtcFixSessionEvent>(EXC_DTCC_UTC_V1_UTC_FIX_SESSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcDtccUtcV1UtcFixSessionEvent) => `${entity.metadata?.eventId}` });

